import {
  saveUpdatedActiveObjectInStore,
} from '@/components/Editor/helpers/fabric/activeObjects/modifyActiveObjectInStore';
import {
  getFontSizeOnResize,
} from '@/components/Editor/helpers/fabric/textObject/getFontSizeOnResize';
import { FabricCanvas } from '@/components/Editor/types/fabric';
import { ToggleTypes } from '@/types';

export const objectModified = (
  canvas: FabricCanvas,
  toggle: ToggleTypes,
): void => {
  canvas[toggle]('object:modified', getFontSizeOnResize);
  canvas[toggle]('object:modified', saveUpdatedActiveObjectInStore);
};
